module.exports = __webpack_public_path__ + "img/vip-bg.425071ad.png";